import React from 'react';
import cx from 'classnames';
import Typography from '../shared/Typography';

import data from '@/services/data/book';
import ExploreOurStoriesBook from './ExploreOurStoriesBook';
import { RootStateOrAny, useSelector } from 'react-redux';
import findService from '@/services/find.service';
import CustomBanner from '../CustomBanner';

type Props = {
  setShowCharacterBuilderModal: React.Dispatch<React.SetStateAction<boolean>>;
  setRedirect: React.Dispatch<React.SetStateAction<string>>;
};

const ExploreOurStories: React.FC<Props> = ({
  setShowCharacterBuilderModal,
  setRedirect
}) => {
  const { booksBuildKeys, characterPreview } = useSelector(
    (state: RootStateOrAny) => state
  );

  return (
    <div className={cx('bg-white overflow-hidden pb-10')}>
      <Typography
        type="h3"
        className="text-center pb-4 pt-8 pl-4 pr-4 lg:pt-20 lg:pl-0 lg:pr-0 font-serif"
        style={{
          fontSize: 32,
          fontFamily: 'Libre Baskerville'
        }}
      >
        Explore our stories
      </Typography>
      <CustomBanner>
        <div
          style={{
            color: 'white',
            fontSize: 16,
            fontFamily: 'Nunito',
            fontWeight: 700
          }}
        >
          Now Starting at just $29.99!
        </div>
      </CustomBanner>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        {booksBuildKeys && booksBuildKeys.length ? (
          data.map((book, idx) => {
            const booksBuildKey = findService(
              booksBuildKeys,
              'keyName',
              book.keyName
            );

            if (booksBuildKey) {
              return (
                <div
                  key={idx}
                  style={{
                    maxWidth: 360,
                    padding: 40,
                    justifyContent: 'center'
                  }}
                >
                  <ExploreOurStoriesBook
                    bookKeyName={book.keyName}
                    bookName={book.title}
                    description={book.descriptionExploreOurStories}
                    character={characterPreview}
                    cover={booksBuildKey.cover}
                    spreadPageSize={booksBuildKey.spreadPageSize}
                    setShowCharacterBuilderModal={setShowCharacterBuilderModal}
                    setRedirect={setRedirect}
                  />
                </div>
              );
            }

            return null;
          })
        ) : (
          <div>
            <svg
              className="animate-spin -ml-1 mr-3 h-10 w-10"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                data-darkreader-inline-stroke=""
                // style="--darkreader-inline-stroke:currentColor;"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                data-darkreader-inline-fill=""
                // style="--darkreader-inline-fill:currentColor;"
              ></path>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExploreOurStories;
